import InputBase from '@material-ui/core/InputBase'
import { withStyles } from '@material-ui/core/styles'

const FilterInput = withStyles(theme => ({
  root: {
    height: '40px',
    width: '185px',
    'label + &': {
      marginTop: theme.spacing(3)
    },
    '& > svg': {
      right: theme.spacing(1)
    }
  },
  input: {
    position: 'relative',
    border: '1px solid #E4E8F1',
    borderRadius: '20px',
    backgroundColor: '#FFFFFF',
    fontSize: 16,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: ['National'],
    '&:focus': {
      borderRadius: 20,
      borderColor: '#E4E8F1',
      backgroundColor: '#FFFFFF'
    }
  }
}))(InputBase)

export default FilterInput
